/**
 * Cópia de `somarMeses` do servidor (`backend/src/services/vaccination/datas.ts`, #530 D4). É a
 * única duplicação da vacinação: o diálogo precisa sugerir o próximo reforço antes de gravar, e
 * quem recusa a data errada continua sendo o servidor. Mudou lá, muda aqui — os testes são os mesmos.
 */

function partes(dataISO: string): { ano: number; mes: number; dia: number } {
  const [ano = NaN, mes = NaN, dia = NaN] = dataISO.slice(0, 10).split('-').map(Number);
  return { ano, mes, dia };
}

function paraTexto(ano: number, mes: number, dia: number): string {
  return `${String(ano).padStart(4, '0')}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
}

/** Soma meses e, quando o dia não existe no mês de chegada, prende no último dia dele. */
export function somarMeses(dataISO: string, meses: number): string {
  const { ano, mes, dia } = partes(dataISO);
  const mesesDesdeOAnoZero = ano * 12 + (mes - 1) + meses;
  const anoFinal = Math.floor(mesesDesdeOAnoZero / 12);
  const mesFinal = mesesDesdeOAnoZero - anoFinal * 12 + 1;
  const ultimoDiaDoMes = new Date(Date.UTC(anoFinal, mesFinal, 0)).getUTCDate();

  return paraTexto(anoFinal, mesFinal, Math.min(dia, ultimoDiaDoMes));
}

/** 'YYYY-MM-DD' → 'DD/MM/YYYY', sem passar por `Date` para o fuso não mudar o dia. */
export function dataBrasileira(dataISO: string | null): string {
  if (!dataISO) return '—';
  const [ano, mes, dia] = dataISO.slice(0, 10).split('-');
  return `${dia}/${mes}/${ano}`;
}
